import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=4b8959fc&scoped=true&"
import script from "./ChartItem.vue?vue&type=script&lang=js&"
export * from "./ChartItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartItem.vue?vue&type=style&index=0&id=4b8959fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8959fc",
  null
  
)

export default component.exports